import React from "react";
import classNames from "classnames";
import { useIdCopy } from "@hooks/useIdCopy";
import styles from "./JournalEntryCells.module.scss";

interface DiffCellProps {
    oldValue?: string | null;
    newValue: string | null;
    hasChanges?: boolean;
    isAdded?: boolean;
    isRemoved?: boolean;
    copyId?: string | number;
    copyLabel?: string;
}

export const DiffCell: React.FC<DiffCellProps> = ({
    oldValue,
    newValue,
    hasChanges,
    isAdded,
    isRemoved,
    copyId,
    copyLabel,
}) => {
    const { getCopyProps } = useIdCopy({ label: copyLabel });

    if (isRemoved) {
        return (
            <span
                className={classNames(styles.newValue, styles.removedText)}
                {...getCopyProps(copyId)}
            >
                {newValue}
            </span>
        );
    }

    if (isAdded) {
        return (
            <span className={styles.addedText} {...getCopyProps(copyId)}>
                {newValue}
            </span>
        );
    }

    if (!hasChanges || oldValue == null || oldValue === newValue) {
        return <span {...getCopyProps(copyId)}>{newValue}</span>;
    }

    return (
        <div className={styles.diffContainer} {...getCopyProps(copyId)}>
            <span className={styles.oldValue}>{oldValue}</span>
            <span className={styles.newValue}>{newValue}</span>
        </div>
    );
};
